import jQuery from 'jquery'

(function($) {
  "use strict";

  $(document).ready(function() {
    if ($('#banner_ad_applications__new').length) {
      init_price_display();
    }
  });

  const init_price_display = function() {
    const set_price_display = function() {
      const $purchase_plan = $('#banner_ad_application_purchase_plan');
      const $price_display_div = $('#price_display_div');
      $price_display_div.hide();

      if ($purchase_plan.val() != '' && $('#banner_ad_application_is_jccg_member_0:checked').length) {
        $price_display_div.text($('#banner_ad_application_purchase_plan option:selected').data('nonmember'));
        $price_display_div.show();

      } else if ($purchase_plan.val() != '' && $('#banner_ad_application_is_jccg_member_1:checked').length) {
        $price_display_div.text($('#banner_ad_application_purchase_plan option:selected').data('member'));
        $price_display_div.show();

      } else {
        $price_display_div.html('&nbsp;');
      }

    }

    $('#banner_ad_application_purchase_plan,#banner_ad_application_is_jccg_member_0,#banner_ad_application_is_jccg_member_1').on('change', set_price_display);

    set_price_display();
  }

})(jQuery);
